import Axios from "axios";
import {
    SET_DISTRICT_LIST,
    UNSET_DISTRICT_LIST,
} from "@/store/mutation-types";
import { getDistrictList } from "@/store/api";

// initial state
const state = {
    getDistrictList: [],
};

const getters = {
    getDistrictList(state) {
        return state.getDistrictList;
    }
};

const mutations = {
    [SET_DISTRICT_LIST](state, data) {
        state.getDistrictList = data;
    },
    [UNSET_DISTRICT_LIST](state) {
        state.getDistrictList = [];
    }
};

const actions = {
    getDistrictList({ commit }, divisionId = null) {
        return new Promise((resolve, reject) => {
            const url = divisionId ? `${getDistrictList}?division_id=${divisionId}` : getDistrictList;
            Axios.get(url)
                .then(function (response) {
                    // Handle different response structures
                    let data = response.data;
                    if (data && data.data) {
                        data = data.data; // If response is wrapped in {data: [...]}
                    }
                    if (!Array.isArray(data)) {
                        data = []; // Ensure it's always an array
                    }
                    commit('SET_DISTRICT_LIST', data);
                    resolve(response);
                })
                .catch(function (error) {
                    console.error('Error loading districts:', error);
                    commit('UNSET_DISTRICT_LIST');
                    reject(error);
                });
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}
